{
	"title": "Results",
	"columns": {
		"order": "No.",
		"competitor": "Competitor",
		"valueWithUnit": "Result ({{unit}})",
		"points": "Points",
		"irm": "Mark",
		"rank": "Rank",
		"outcome": "Outcome",
		"detail": "Details",
		"state": "Save state",
		"bib": "Bib",
		"records": "Records",
		"round": "R{{n}}",
		"liftAttempt": "{{lift}} {{n}}",
		"result": "Result",
		"series": "S{{n}}",
		"end": "E{{n}}",
		"roundLong": "Round {{n}}",
		"seriesLong": "Series {{n}}",
		"endLong": "End {{n}}"
	},
	"unit": {
		"TIME": "time",
		"DISTANCE": "m",
		"WEIGHT": "kg",
		"POINTS": "points",
		"SCORE": "score"
	},
	"note": {
		"generic": "Details are shown as entered. They can't be edited on this screen.",
		"family": "The full {{family}} screen is coming. Until then, enter the result, points and marks here. Details are shown as stored and can't be edited here."
	},
	"detail": {
		"meet": "Meet settings",
		"more_one": "and {{count}} more line",
		"more_other": "and {{count}} more lines"
	},
	"empty": {
		"title": "No competitors in this meet yet",
		"body": "Add them in the start list, then enter results here."
	},
	"aria": {
		"value": "Result, {{name}}",
		"points": "Points, {{name}}",
		"irm": "Mark, {{name}}"
	},
	"waiting": "Not decided yet",
	"bib": "Bib {{bib}}",
	"source": {
		"WINNER": "Winner of {{meet}}",
		"LOSER": "Loser of {{meet}}",
		"meetRank": "Place {{rank}} in {{meet}}",
		"poolRank": "Place {{rank}} in group {{pool}}",
		"phaseRank": "Place {{rank}} from the previous round",
		"none": "To be decided"
	},
	"irmNone": "No mark",
	"irmOption": "{{code}} ({{name}})",
	"parse": {
		"empty": "Enter a value",
		"format": "This cell takes a number",
		"precision": "Too many decimal places. Nothing is rounded: type it as the board shows it.",
		"range": "Outside the allowed range"
	},
	"field": {
		"result_value": "result",
		"result_display": "displayed result",
		"points": "points",
		"irm": "mark",
		"rank": "rank",
		"outcome": "outcome",
		"records": "records",
		"detail": "details",
		"row": "the row"
	},
	"refused": {
		"field": "Check the {{fields}}.",
		"official": "The meet is official. To change results, change the Meet status (you will be asked to confirm).",
		"locked": "The medal desk locked this event.",
		"not_found": "This slot is no longer in the meet. Reload the meet.",
		"forbidden": "Your role can't enter results.",
		"conflict": "The server refused this change.",
		"unknown": "The server refused this change (code {{code}})."
	},
	"row": {
		"restored": "Kept on this device from before",
		"retry": "Will be sent again",
		"pendingTheirs": "Loading their version…",
		"theirs": "Saved by them: {{value}}"
	},
	"lift": {
		"SNATCH": "Snatch",
		"CLEAN_JERK": "Clean & jerk",
		"BENCH": "Bench press"
	},
	"judged": {
		"difficulty": "D score",
		"penalty": "Penalty",
		"total": "Total",
		"rank": "Rank",
		"panel": "Judges {{group}}",
		"component": {
			"execution": "E score",
			"artistry": "A score",
			"bonus": "Bonus",
			"technical": "Technical",
			"presentation": "Presentation"
		}
	},
	"cell": {
		"good": "Good lift",
		"fail": "No lift",
		"declared": "Declared, not lifted yet",
		"discarded": "Discarded"
	},
	"rounds": {
		"parts": "Holes, ends or shots"
	},
	"lifts": {
		"lot": "Lot no.",
		"bodyweight": "Body weight",
		"entryTotal": "Entry total",
		"kg": "{{kg}} kg"
	},
	"panel": {
		"collapseAll": "Hide all",
		"expandAll": {
			"judges": "Show all judges' scores",
			"details": "Show all details"
		},
		"toggle": {
			"judges": "Judges",
			"rounds": "Rounds",
			"lifts": "Draw",
			"lines": "Details"
		},
		"toggleFor": "{{what}}, {{name}}"
	},
	"tally": {
		"inner_tens": "X"
	},
	"tallyLong": {
		"inner_tens": "Inner tens"
	}
}
